import * as React from "react";
import { MobileMenuLevel } from "./MobileMenuLevel";
import {
  IMobileMenuSliderProps,
  IMobileMenuSliderState,
} from "./MobileMenuSlider.types";

export class MobileMenuSlider extends React.Component<
  IMobileMenuSliderProps,
  IMobileMenuSliderState
> {
  private levelWrapper: HTMLDivElement;

  constructor(props: IMobileMenuSliderProps) {
    super(props);

    this.state = {
      activeMenuItem: this.props.activeMenuItem,
    };
  }

  public componentDidUpdate(incomingProps: IMobileMenuSliderProps): void {
    // If we get a *NEW* activeMenuItem we want to trigger the animation
    if (incomingProps.activeMenuItem !== this.props.activeMenuItem) {
      this.runAnimation();
    }
  }

  runAnimation = (): void => {
    if (this.props.isNavigatingBackwards)
      this.levelWrapper.classList.add("reverse");
    this.levelWrapper.classList.add("transition");
    this.levelWrapper.classList.add("swipe-out");
    setTimeout(() => {
      this.levelWrapper.classList.remove("transition");
      setTimeout(() => {
        this.setState(() => {
          return {
            activeMenuItem: this.props.activeMenuItem,
          };
        });
        this.levelWrapper.classList.remove("swipe-out");
        this.levelWrapper.classList.add("re-center");
        setTimeout(() => {
          this.levelWrapper.classList.add("transition");
          this.levelWrapper.classList.add("pop-in");
          setTimeout(() => {
            this.levelWrapper.classList.remove("transition");
            this.levelWrapper.classList.remove("re-center");
            this.levelWrapper.classList.remove("pop-in");
            this.levelWrapper.classList.remove("reverse");
          }, 250);
        }, 1);
      }, 1);
    }, 250);
  };

  public render() {
    return (
      <div
        className="mobile-menu__slider"
        ref={(ref) => (this.levelWrapper = ref)}
      >
        <MobileMenuLevel
          language={this.props.language}
          activeMenuItem={this.state.activeMenuItem}
          addChildrenToTreeCallback={this.props.addChildrenToTreeCallback}
          setActiveMenuItemCallback={this.props.setActiveMenuItemCallback}
          isStartPage={this.props.isStartPage}
        />
      </div>
    );
  }
}
